// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CancelTurn {\n  height: 100%;\n}\n.blueText {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 25px;\n  color: #69cdfe;\n}\n.logoCancelTurn {\n  top: 0;\n  left: auto;\n  transform: none;\n  margin-top: 56px;\n  margin-bottom: 20%;\n  position: relative;\n}\n.text-confirm_data {\n  width: 177px;\n}\n.boxDarker {\n  background: #202d78;\n  border-radius: 20px;\n}", ""]);
// Exports
module.exports = exports;
